// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-95c7eee0]{min-height:100vh;display:flex;align-items:center;flex-direction:column;justify-content:center}.wrapper .font[data-v-95c7eee0]{color:#fff;font-size:.9rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
